import * as pxp from '../lib/pxp'

/**
 * STAGE:
 *   https://www.msmaster.qa.paypal.com/elmo/experiment/102924

 * Conditions:
 * - Control: Not using Open Banking.
 * - Treatment: Using Open Banking.
 */

export function isOpenBankingTreatment() {
  return pxp.isTreatment('Trmt_p2p_real_time_balance_check_exp_test')
}
